module.exports = "/_next/static/images/avatar-mask-blue-9283f257.png";